import moment from 'moment';

const formatDate = (dateToFormat, country, locale) => {
  try {
    if (!dateToFormat) {
      return '';
    }

    let formatedDate = moment(dateToFormat).locale(locale);

    if (!formatedDate.isValid()) {
      return '';
    }

    // Handle special formats per country
    switch (country) {
      case 'kr':
      case 'c2':
        formatedDate = formatedDate.format('YYYY..MM.DD');
        break;
      case 'jp':
        formatedDate = formatedDate.format('MMM DD日 YYYY');
        break;
      case 'mx':
        formatedDate = formatedDate.format('DD MMM YYYY');
        break;
      case 'pl':
        formatedDate = formatedDate.format('DD/MM/YY');
        break;
      default:
        formatedDate = formatedDate.format('MMM DD YYYY');
    }

    const refinedDate = formatedDate.includes('.')
      ? formatedDate.replace('.', '')
      : formatedDate;

    return refinedDate.charAt(0).toUpperCase() + refinedDate.slice(1);
  } catch (error) {
    return '';
  }
};

export default formatDate;
